export const DIRECTORY_TITLE_MAX_LENGTH = 250;

export function isDirectoryTitleValid(title: string): boolean {
  return title.trim().length > 0;
}

export function normalizeDirectoryTitle(title: string): string {
  return title.trim().toLowerCase();
}
